var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import {
    isUrlAccepted,
    Url
} from '@ef-carbon/primitive';
import assign from './assign';
import { register } from './factory';
import Type from './Type';
function isIOptions(init) {
    return init !== null && typeof init === 'object' && !isUrlAccepted(init);
}
function options(init) {
    return isIOptions(init) ? init : { url: init };
}
export class Generic {
    constructor(init) {
        this.type = Type.Image;
        this.aspect = undefined;
        const _a = options(init), {url, aspect, copy} = _a, rest = __rest(_a, [
                'url',
                'aspect',
                'copy'
            ]);
        this.url = new Url(url);
        if (aspect !== undefined) {
            this.aspect = typeof aspect !== 'number' ? parseInt(`${ aspect }`, 10) : aspect;
            if (isNaN(aspect) || aspect === Infinity || aspect < 0) {
                throw TypeError(`Invalid aspect (${ aspect }) value for '${ this.url }' video`);
            }
        }
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.url.configurable = false;
        descriptors.aspect.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Image extends Generic {
}
export const klass = Image;
export default Image;
register(Type.Image, Image);    //# sourceMappingURL=Image.js.map
